import React, { useEffect, useState } from "react";
import columns from "../../../columns/payroll/payrollHistory";
import SkeletonTable from "../../../components/table/SkeletonTable";
import { EmployeePayrollHistory } from "../../../api/request/payroll/payroll";
import toast from "react-hot-toast";

const PayrollHistory = ({ empData }) => {
  const [employeeHistory, setEmployeeHistory] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const handleViewHistory = async () => {
    if (!empData) return;
    try {
      setEmployeeLoading(true);
      const { data } = await EmployeePayrollHistory({
        employee_id: empData?.id,
      });
      if (data?.status) {
        setEmployeeHistory(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <p
                  className={`${
                    item?.status === "entered"
                      ? "text-green-500"
                      : "text-red-600"
                  } font-bold capitalize`}
                >
                  {item?.status}
                </p>
              ),
            };
          })
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    handleViewHistory();
  }, [empData]);

  return (
    <>
      <SkeletonTable
        columns={columns}
        data={employeeHistory || []}
        isLoading={employeeLoading}
        pagination={true}
      />
    </>
  );
};

export default PayrollHistory;
